import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueMoment from 'vue-moment'
import moment from 'moment'
import Clipboard from 'v-clipboard'
 
Vue.use(Clipboard)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
 
Vue.use(VueMoment, {moment})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
